var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'error': _setup.getError}},[_vm._t("default"),(_setup.getError)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.$t(_setup.getError)))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }